import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { LandingComponent } from './landing/landing.component';
import { ProfileComponent } from './profile/profile.component';
import { SignupComponent } from './signup/signup.component';
import { PopupModule } from 'ng2-opd-popup';
import { IndexComponent } from './index/index.component';
import { IndexAccueilComponent } from './index/index-accueil/index-accueil.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { InfoVisiteurComponent, NgbdModalContent_Info } from '../page/modal/ajout-docteur/info-visiteur/info-visiteur.component';
import { AdminComponent } from './admin/admin.component';
import { NgxPaginationModule } from 'ngx-pagination';
//import { MedecinCmsComponent } from './index/medecin-cms/medecin-cms.component';
//import {MatProgressSpinnerModule} from '@angular/material/progress-spinner'; 

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        PdfViewerModule,
        PopupModule.forRoot(),
        NgxPaginationModule
       // MatProgressSpinnerModule
    ],
    declarations: [
        LandingComponent,
        SignupComponent,
        ProfileComponent,
        IndexComponent,
        IndexAccueilComponent,
        InfoVisiteurComponent,
        NgbdModalContent_Info,
        AdminComponent,        
        
    ],
    entryComponents: [NgbdModalContent_Info] ,
})
export class ExamplesModule { }
